/* eslint-disable @typescript-eslint/ban-ts-comment */
import ProjectRole, { ProjectMemberRoleJSON, ProjectMemberRoleType } from '@projectMembers/models/projectRole';
import User, { UserJson } from 'src/new_arch/models/user/user';

type EditorAccessStateJSON = {
	state: 'pending' | 'trial' | 'full' | 'limited';
	days_remaining?: number;
	modal_seen?: boolean;
} | null;

export type EditorAccessState = {
	state: 'pending' | 'trial' | 'full' | 'limited';
	daysRemaining?: number;
	modalSeen?: boolean;
} | null;

export type ProjectMemberJSON = {
	id: number,
	user: UserJson,
	role: ProjectMemberRoleJSON,
	editor_access_state?: EditorAccessStateJSON
};

export type ProjectMemberParams = {
	id: number,
	user: User,
	roleType: ProjectMemberRoleType,
	editorAccessState?: EditorAccessState
}

export default class ProjectMember {
	id: number;
	user: User;
	roleType: ProjectMemberRoleType;
	editorAccessState: EditorAccessState;

	constructor( { id, user, roleType, editorAccessState = null }: ProjectMemberParams ) {
		this.id = id;
		this.user = user;
		this.roleType = roleType;
		this.editorAccessState = editorAccessState;
	}

	get role() {
		return ProjectRole.fromID( this.roleType )!;
	}

	get isOwner() {
		return this.roleType === ProjectMemberRoleType.ProjectOwner;
	}

	get isGuest() {
		return this.user.isGuest;
	}

	get isLimitedEditor() {
		return this.roleType === ProjectMemberRoleType.ProjectLimitedEditor;
	}

	hasRole( role: ProjectMemberRoleType ) {
		return this.roleType === role;
	}

	static fromJson( json: ProjectMemberJSON ): ProjectMember {
		const editorAccessState = json.editor_access_state
			? {
				state: json.editor_access_state.state,
				daysRemaining: json.editor_access_state.days_remaining,
				modalSeen: json.editor_access_state.modal_seen ?? false
			}
			: null;

		return new ProjectMember( {
			id: json.id,
			user: User.fromJson( json.user ),
			roleType: json.role.type,
			editorAccessState
		} );
	}

	toJson(): ProjectMemberJSON {
		return {
			id: this.id,
			user: this.user.toJson(),
			role: {
				id: this.id,
				type: this.roleType
			}
		};
	}
}
